"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _layouts_1 = require("@layouts");
const _utils_1 = require("@utils");
// Component
var DestinationsPage = function DestinationsPage(_ref) {
    var contentfulDestinationsLandingPage = _ref.data.contentfulDestinationsLandingPage;
    if (!contentfulDestinationsLandingPage)
        return null;
    var _ref2 = contentfulDestinationsLandingPage, title = _ref2.title, seoTitle = _ref2.seoTitle, listOfFeaturedDestinations = _ref2.listOfFeaturedDestinations;
    if (!listOfFeaturedDestinations)
        return null;
    var _React$useState = react_1.default.useState(9), postsToShow = _React$useState[0], setPostsToShow = _React$useState[1];
    var _React$useState2 = react_1.default.useState(listOfFeaturedDestinations.filter(function (article) {
        var _article$title;
        return !_utils_1.checkPlaceholderContent(article === null || article === void 0 ? void 0 : (_article$title = article.title) === null || _article$title === void 0 ? void 0 : _article$title.title);
    })), visibleArticles = _React$useState2[0];
    var loadMore = function loadMore() {
        return setPostsToShow(postsToShow + 9);
    };
    var links = [];
    listOfFeaturedDestinations.filter(function (article) {
        return !!article;
    }).map(function (article) {
        var _article$title2;
        if (!article)
            return null;
        links.push({
            label: article === null || article === void 0 ? void 0 : (_article$title2 = article.title) === null || _article$title2 === void 0 ? void 0 : _article$title2.title,
            to: "/destinations/" + (article === null || article === void 0 ? void 0 : article.slug)
        });
    });
    var quickLinksBar = /*#__PURE__*/ react_1.default.createElement(molecules_1.QuickLinksBar, {
        links: links
    });
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.Layout, {
        subHeaderContent: quickLinksBar
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SeoTags, {
        title: seoTitle,
        urlPath: "/destinations"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.PageHeader, {
        title: title
    }), /*#__PURE__*/ react_1.default.createElement(TeaserList, null, visibleArticles === null || visibleArticles === void 0 ? void 0 : visibleArticles.filter(function (article) {
        return article !== null;
    }).map(function (article, index) {
        var _article$indexImage, _article$indexImage$f, _article$title3, _article$subtitle, _article$subtitle$chi;
        return /*#__PURE__*/ react_1.default.createElement(molecules_1.AlternatingImageLayout, {
            key: article.slug,
            url: "/destinations/" + article.slug,
            imageUrl: (_article$indexImage = article.indexImage) === null || _article$indexImage === void 0 ? void 0 : (_article$indexImage$f = _article$indexImage.file) === null || _article$indexImage$f === void 0 ? void 0 : _article$indexImage$f.url,
            orientation: index % 2 ? 'left' : 'right',
            title: (_article$title3 = article.title) === null || _article$title3 === void 0 ? void 0 : _article$title3.title,
            caption: (_article$subtitle = article.subtitle) === null || _article$subtitle === void 0 ? void 0 : (_article$subtitle$chi = _article$subtitle.childMarkdownRemark) === null || _article$subtitle$chi === void 0 ? void 0 : _article$subtitle$chi.html,
            buttonLabel: "Explore"
        });
    }), (visibleArticles === null || visibleArticles === void 0 ? void 0 : visibleArticles.length) === 0 && /*#__PURE__*/ react_1.default.createElement("h1", null, "No results."), visibleArticles && postsToShow < (visibleArticles === null || visibleArticles === void 0 ? void 0 : visibleArticles.length) && /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        onClick: function onClick() {
            return loadMore();
        },
        type: "outline",
        size: "large",
        center: true,
        lines: true
    }, "Load More")), /*#__PURE__*/ react_1.default.createElement(molecules_1.RegisterInLayout, null), /*#__PURE__*/ react_1.default.createElement(organisms_1.HomepageHero, null));
}; // Styling
// note: if this shares anything with TeaserList on landing page, turn into molecule
var TeaserList = styled_components_1.default.div.withConfig({
    displayName: "destinations__TeaserList",
    componentId: "rzrkb9-0"
})([""]); // Data
exports.query = "2410241150"; // Typing
exports.default = DestinationsPage;
